export default "__VITE_ASSET__Ct4de92n__"